import { render, staticRenderFns } from "./QuestionGrid.vue?vue&type=template&id=4c6fc1f4"
import script from "./QuestionGrid.vue?vue&type=script&lang=js"
export * from "./QuestionGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports